import { LuMoon, LuSunMedium } from "react-icons/lu";

import { useTheme } from "../../context/ThemeContext";
import {
  getNextPreferenceLabel,
  getPreferenceLabel,
} from "../../utils/theme";
import styles from "./ThemeToggle.module.scss";

export default function ThemeToggle({ className = "" }) {
  const { preference, resolved, cycleTheme } = useTheme();
  const label = getPreferenceLabel(preference);
  const nextLabel = getNextPreferenceLabel(preference);

  return (
    <button
      type="button"
      className={`${styles.toggle} ${className}`.trim()}
      onClick={cycleTheme}
      aria-label={`${label}. Activar ${nextLabel.toLowerCase()}.`}
      title={`${label} — clic para ${nextLabel.toLowerCase()}`}
    >
      {resolved === "dark" ? (
        <LuSunMedium aria-hidden strokeWidth={2} />
      ) : (
        <LuMoon aria-hidden strokeWidth={2} />
      )}
    </button>
  );
}
